import React, { useEffect, useRef } from "react";
import "./myproducts.scss";

import { useState } from "react";
import { Range, getTrackBackground } from "react-range";
import Table from "react-bootstrap/Table";
import Pagination from "react-bootstrap/Pagination";

import Modal from "react-bootstrap/Modal";

import Offcanvas from "react-bootstrap/Offcanvas";
import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";
import CustomSelect from "./CustomSelect";
import axios from "axios";
import { API_URL } from "utils/ApiUrl";
import Loader from "utils/loader";
import { useHistory } from "react-router-dom";
import copy from "copy-to-clipboard";
import useWeb3 from "hooks/useWeb3";

const Users = ({ search, setSearch }) => {

  const web3 = useWeb3();
  const debounceTimeout = useRef(null);

  console.log(search, setSearch, "searchsearchsearchsearch");

  // State to manage referral data, pagination, and loading
  const history = useHistory();

  const [users, setUsers] = useState([]);

  console.log(users, "usersusersusersusers");

  const [offset, setOffset] = useState(1); // page number
  const [limit] = useState(10); // items per page
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [values, setValues] = useState([20, 80]);
  const [show, setShow] = useState(false);

  const [inputFocused, setInputFocused] = useState(false); // State to track input focus
  // const [searchText, setSearchText] = useState(""); // State to track search text

  const [show1, setShow1] = useState(false);

  const MIN = 0;
  const MAX = 100;
  // Fetch users from API
  const fetchUsers = async () => {
    // setLoading(true);
    const accessToken = localStorage.getItem("token");

    // Determine whether the search is a wallet address or a name
    const isWalletAddress = web3.utils.isAddress(search);
    setLoading(true);

    let queryParams = isWalletAddress
      ? { ...(search && { walletAddress: search }), offset: '1', limit } // Only add walletAddress if search is not empty
      : { ...(search && { name: search }), offset, limit }; // Only add name if search is not empty
    // Otherwise, add name
    // setLoading(true)

    try {
      const response = await axios.get(`${API_URL}/users`, {
        params: queryParams, // Dynamically pass query params
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "content-type": "application/json",
        },
      });
      const data = response.data.data;

      console.log("Users activity data : ", data);
      setUsers(data.users);
      setTotalItems(data.count); // Total number of items
      setTotalPages(data.pages); // Total pages from API
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };


  // useEffect(() => {
  //   fetchUsers();
  // }, [offset, limit, search]);

  useEffect(() => {
    if (search) {
      // Clear the previous timeout if the user continues typing
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      // Set a new timeout to trigger the fetch after 500ms
      debounceTimeout.current = setTimeout(() => {
        fetchUsers(search);
      }, 700); // Adjust delay time (in milliseconds) as needed
    } else if (search === "") {
      // If search is empty, fetch all projects
      fetchUsers();
    }

    // Cleanup function to clear timeout
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, [search, offset, limit,]);





  // Pagination logic
  const handlePageChange = (page) => {
    setOffset(page);
  };

  // const handleUserDetailClick = (userId, userWalletAddress) => {
  //   if (userWalletAddress) {
  //     history.push({
  //       pathname: `/admin/user/${userId}`,
  //       state: { userWalletAddress: userWalletAddress },
  //     });
  //   } else {
  //     history.push(`/admin/user/${userId}`);
  //   }
  // };

  const handleToggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  // const handleInputChange = (e) => {
  //   setSearchText(e.target.value); // Update search text state
  // };

  const handleInputFocus = () => {
    setInputFocused(true); // Set input focus state to true
  };

  const handleInputBlur = () => {
    setInputFocused(false); // Set input focus state to false
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const options = [
    { value: "1", label: "electricity & electronics" },
    { value: "2", label: "Computers & programs" },
    { value: "3", label: "For home, kindergarten & office" },
    { value: "4", label: "Leisure & sports" },
    { value: "5", label: "gifts & miscellaneous" },
    { value: "6", label: "Children" },
    { value: "7", label: "Beauty & health care" },
    { value: "8", label: "Vehicle & accessories" },
    { value: "9", label: "Fashion" },
    { value: "10", label: "Toilets" },
    { value: "11", label: "Sports & Outdoors" },
    { value: "12", label: "Household" },
    { value: "13", label: "Electronics" },
    { value: "14", label: "Computers & Accessories" },
    { value: "15", label: "TV & Video" },
  ];


  



  const handleSelectChange = (selectedOptions) => {
    console.log("Selected options:", selectedOptions);
  };

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const [copiedIndex, setCopiedIndex] = useState(null); // Store the index of the copied item
  console.log(copiedIndex, "copiedIndexcopiedIndexcopiedIndexcopiedIndex");

  const handleCopyToClipboard = (index, walletAddress) => {
    console.log(index, "indexxx");

    copy(walletAddress); // Copy the wallet address to the clipboard
    setCopiedIndex(index); // Set the index of the copied item

    // Remove the copied message after 2 seconds
    setTimeout(() => {
      setCopiedIndex(null); // Reset the copied index to null
    }, 2000);
  };

  const changeDateFormate = (createdAt) => {
    console.log("🚀 ~ changeDateFormate ~ createdAt:", createdAt);
    const originalDate = new Date(createdAt);

    // Format the date and time
    const formattedDate = originalDate.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      
      hour12: true, // Use 12-hour clock, you can set it to false for 24-hour clock
    });

    // Return the formatted date and time
    return formattedDate;
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="content">
            <section className="products_section">
              <div className="outterwrapper">
                <div className="innerleft">
                  <div className="Products">
                    <div className="respheight">
                      <div className="tablemains">
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>
                                <p className="namesvg">
                                  User
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="8"
                                    height="11"
                                    viewBox="0 0 8 11"
                                    fill="none"
                                  >
                                    <path
                                      d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                      fill="#D3D3D3"
                                    />
                                    <path
                                      d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                      fill="black"
                                    />
                                  </svg>
                                </p>
                              </th>
                              <th>
                                <p className="namesvg">
                                  Email
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="8"
                                    height="11"
                                    viewBox="0 0 8 11"
                                    fill="none"
                                  >
                                    <path
                                      d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                      fill="#D3D3D3"
                                    />
                                    <path
                                      d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                      fill="black"
                                    />
                                  </svg>
                                </p>
                              </th>
                              <th>
                                <p className="namesvg">
                                  Contact
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="8"
                                    height="11"
                                    viewBox="0 0 8 11"
                                    fill="none"
                                  >
                                    <path
                                      d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                      fill="#D3D3D3"
                                    />
                                    <path
                                      d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                      fill="black"
                                    />
                                  </svg>
                                </p>
                              </th>
                              <th>
                                <p className="namesvg">Wallet Address</p>
                              </th>
                              <th>
                                <p className="namesvg">
                                  Date Joined
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="8"
                                    height="11"
                                    viewBox="0 0 8 11"
                                    fill="none"
                                  >
                                    <path
                                      d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                      fill="#D3D3D3"
                                    />
                                    <path
                                      d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                      fill="black"
                                    />
                                  </svg>
                                </p>
                              </th>
                              {/* <th>
                                <p className="namesvg">
                                  Commission %
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="8"
                                    height="11"
                                    viewBox="0 0 8 11"
                                    fill="none"
                                  >
                                    <path
                                      d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                      fill="#D3D3D3"
                                    />
                                    <path
                                      d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                      fill="black"
                                    />
                                  </svg>
                                </p>
                              </th> */}
                              <th>
                                <p className="namesvg">
                                  Action
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="8"
                                    height="11"
                                    viewBox="0 0 8 11"
                                    fill="none"
                                  >
                                    <path
                                      d="M7.44734 6.21436H4.26892H1.40681C0.91704 6.21436 0.672154 6.86485 1.01908 7.24618L3.66181 10.151C4.08525 10.6164 4.774 10.6164 5.19745 10.151L6.2025 9.04626L7.84017 7.24618C8.18199 6.86485 7.93711 6.21436 7.44734 6.21436Z"
                                      fill="#D3D3D3"
                                    />
                                    <path
                                      d="M7.44734 4.78564H4.26892H1.40681C0.91704 4.78564 0.672154 4.13515 1.01908 3.75382L3.66181 0.849019C4.08525 0.383578 4.774 0.383578 5.19745 0.849019L6.2025 1.95374L7.84017 3.75382C8.18199 4.13515 7.93711 4.78564 7.44734 4.78564Z"
                                      fill="black"
                                    />
                                  </svg>
                                </p>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {users?.map((user, index) => {
                              return (
                                <tr key={user._id}>
                                  <td>
                                    <p className="pargraphapple">
                                      {user?.name ||
                                        user?.email?.split("@")[0] ||
                                        "N/A"}

                                    </p>
                                  </td>
                                  <td>
                                    <p className="pargraphapple">
                                      {user.email || "N/A"}
                                    </p>
                                  </td>
                                  <td>
                                    <p className="pargraphapple" >
                                      {user.phoneNumber || "-"}
                                    </p>
                                  </td>
                                  <td>
                                    {user.walletAddress ? (
                                      <>
                                        <p className="pargraphapple">
                                          <span>
                                            {user.walletAddress
                                              ? `${user.walletAddress.slice(0, 5)}...${user.walletAddress.slice(-5)}`
                                              : "N/A"}
                                          </span>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 18 18"
                                            fill="none"
                                            className="pl-3 mx-3"
                                            onClick={() => handleCopyToClipboard(index, user?.walletAddress)}
                                          >
                                            <path
                                              opacity="0.2"
                                              d="M15.1875 2.8125V11.8125H11.8125V6.1875H6.1875V2.8125H15.1875Z"
                                              fill="#10312B"
                                            />
                                            <path
                                              d="M15.1875 2.25H6.1875C6.03832 2.25 5.89524 2.30926 5.78975 2.41475C5.68426 2.52024 5.625 2.66332 5.625 2.8125V5.625H2.8125C2.66332 5.625 2.52024 5.68426 2.41475 5.78975C2.30926 5.89524 2.25 6.03832 2.25 6.1875V15.1875C2.25 15.3367 2.30926 15.4798 2.41475 15.5852C2.52024 15.6907 2.66332 15.75 2.8125 15.75H11.8125C11.9617 15.75 12.1048 15.6907 12.2102 15.5852C12.3157 15.4798 12.375 15.3367 12.375 15.1875V12.375H15.1875C15.3367 12.375 15.4798 12.3157 15.5852 12.2102C15.6907 12.1048 15.75 11.9617 15.75 11.8125V2.8125C15.75 2.66332 15.6907 2.52024 15.5852 2.41475C15.4798 2.30926 15.3367 2.25 15.1875 2.25ZM11.25 14.625H3.375V6.75H11.25V14.625ZM14.625 11.25H12.375V6.1875C12.375 6.03832 12.3157 5.89524 12.2102 5.78975C12.1048 5.68426 11.9617 5.625 11.8125 5.625H6.75V3.375H14.625V11.25Z"
                                              fill="#10312B"
                                            />
                                          </svg>
                                        </p>
                                        {copiedIndex === index && (
                                          <div className="copied-message">
                                            <span>Copied!</span>
                                          </div>
                                        )}
                                      </>
                                    ) : (
                                      <div style={{ textAlign: 'center' }}>
                                        <span >N/A</span>
                                        {/* // If walletAddress doesn't exist, just show N/A */}

                                      </div>
                                    )}
                                  </td>

                                  {/* 
                                  <td>
                                    <p className="pargraphapple">
                                      {new Date(
                                        user.createdAt
                                      ).toLocaleDateString() || "N/A"}
                                    </p>
                                  </td> */}
                                  <td>
                                    <p className="pargraphapple">
                                      {user.createdAt
                                        ?
                                        // new Date(
                                        //   transaction.userId.createdAt
                                        // ).toLocaleDateString()
                                        changeDateFormate(user?.createdAt)
                                        : "N/F"}
                                      {/* Fallback to "N/A" if createdAt is missing */}
                                    </p>
                                  </td>

                                  {/* <td>
                                    <p className="pargraphapple" style={{ justifyContent: "center" }}>
                                      {user.totalCommission.toFixed(2)
                                        ? `${user.totalCommission.toFixed(2)}%`
                                        : "0%"}
                                    </p>
                                  </td> */}

                                  <td>
                                    <Link to={`/admin/usersdetail/${user._id}`}>
                                      <button className="addproduct">
                                        Detail
                                      </button>
                                    </Link>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                        <div className="paginationdiv">
                          <p>
                            {totalItems === 0
                              ? "SHOWING 0 OF 0"
                              : `SHOWING ${(offset - 1) * limit + 1}-${Math.min(
                                offset * limit,
                                totalItems
                              )} OF ${totalItems}`}
                          </p>
                          <div className="numberbagidiv">
                            <Pagination>
                              <Pagination.Prev
                                onClick={() => {
                                  if (totalItems > 0)
                                    handlePageChange(Math.max(1, offset - 1));
                                }}
                                disabled={offset === 1 || totalItems === 0}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  className="rightarow"
                                >
                                  <path
                                    opacity="0.2"
                                    d="M5 6.5L8 9.5V3.5L5 6.5Z"
                                    fill="#858585"
                                  />
                                  <path
                                    d="M1.64625 6.85366L4.64625 9.85366C4.74007 9.94748 4.86732 10.0002 5 10.0002C5.13268 10.0002 5.25993 9.94748 5.35375 9.85366C5.44757 9.75984 5.50028 9.63259 5.50028 9.49991C5.50028 9.36722 5.44757 9.23998 5.35375 9.14616L2.70687 6.49991L5.35375 3.85366C5.40021 3.8072 5.43705 3.75205 5.4622 3.69135C5.48734 3.63066 5.50028 3.5656 5.50028 3.49991C5.50028 3.43421 5.48734 3.36915 5.4622 3.30846C5.43705 3.24776 5.40021 3.19261 5.35375 3.14616C5.25993 3.05234 5.13268 2.99963 5 2.99963C4.9343 2.99963 4.86925 3.01257 4.80855 3.03771C4.74786 3.06285 4.69271 3.0997 4.64625 3.14616L1.64625 6.14616C1.59976 6.19259 1.56288 6.24774 1.53772 6.30844C1.51256 6.36913 1.49961 6.4342 1.49961 6.49991C1.49961 6.56561 1.51256 6.63068 1.53772 6.69138C1.56288 6.75207 1.59976 6.80722 1.64625 6.85366ZM4.64625 6.85366L7.64625 9.85366C7.71618 9.92366 7.8053 9.97134 7.90235 9.99067C7.99939 10.01 8.09998 10.0001 8.1914 9.96222C8.28281 9.92434 8.36092 9.86019 8.41586 9.7779C8.4708 9.6956 8.50008 9.59885 8.5 9.49991V7.02303C9.8658 7.14928 11.1353 7.78068 12.0601 8.79366C12.9849 9.80665 13.4984 11.1283 13.5 12.4999C13.5 12.6325 13.5527 12.7597 13.6464 12.8535C13.7402 12.9472 13.8674 12.9999 14 12.9999C14.1326 12.9999 14.2598 12.9472 14.3536 12.8535C14.4473 12.7597 14.5 12.6325 14.5 12.4999C14.4979 10.8631 13.8793 9.28714 12.7674 8.08601C11.6554 6.88488 10.1318 6.14674 8.5 6.01866V3.49991C8.50008 3.40096 8.4708 3.30421 8.41586 3.22191C8.36092 3.13962 8.28281 3.07547 8.1914 3.03759C8.09998 2.99972 7.99939 2.98982 7.90235 3.00914C7.8053 3.02847 7.71618 3.07615 7.64625 3.14616L4.64625 6.14616C4.59976 6.19259 4.56288 6.24774 4.53772 6.30844C4.51256 6.36913 4.49961 6.4342 4.49961 6.49991C4.49961 6.56561 4.51256 6.63068 4.53772 6.69138C4.56288 6.75207 4.59976 6.80722 4.64625 6.85366ZM5.70875 6.49991L7.5 4.70678V8.29303L5.70875 6.49991Z"
                                    fill="#858585"
                                  />
                                </svg>
                              </Pagination.Prev>
                              {/* Pagination Items */}
                              {totalPages <= 5 ? (
                                // Show all pages if totalPages <= 5
                                [...Array(totalPages)].map((_, i) => (
                                  <Pagination.Item
                                    key={i}
                                    active={i + 1 === offset}
                                    onClick={() => handlePageChange(i + 1)}
                                  >
                                    {i + 1}
                                  </Pagination.Item>
                                ))
                              ) : (
                                // Handle ellipsis for large number of pages
                                <>
                                  <Pagination.Item
                                    active={offset === 1}
                                    onClick={() => handlePageChange(1)}
                                  >
                                    1
                                  </Pagination.Item>
                                  {offset > 3 && (
                                    <Pagination.Ellipsis disabled />
                                  )}
                                  {offset === 1 || offset === totalPages
                                    ? [...Array(3)].map((_, i) => {
                                      const page =
                                        offset === 1
                                          ? i + 1
                                          : totalPages - 3 + i + 1;
                                      return (
                                        <Pagination.Item
                                          key={page}
                                          active={page === offset}
                                          onClick={() =>
                                            handlePageChange(page)
                                          }
                                        >
                                          {page}
                                        </Pagination.Item>
                                      );
                                    })
                                    : [...Array(3)].map((_, i) => {
                                      const page = offset - 1 + i;
                                      return (
                                        <Pagination.Item
                                          key={page}
                                          active={page === offset}
                                          onClick={() =>
                                            handlePageChange(page)
                                          }
                                        >
                                          {page}
                                        </Pagination.Item>
                                      );
                                    })}
                                  {offset < totalPages - 2 && (
                                    <Pagination.Ellipsis disabled />
                                  )}
                                  <Pagination.Item
                                    active={offset === totalPages}
                                    onClick={() => handlePageChange(totalPages)}
                                  >
                                    {totalPages}
                                  </Pagination.Item>
                                </>
                              )}
                              <Pagination.Next
                                onClick={() => {
                                  if (totalItems > 0)
                                    handlePageChange(
                                      Math.min(totalPages, offset + 1)
                                    );
                                }}
                                disabled={
                                  offset === totalPages || totalItems === 0
                                }
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  className="leftti"
                                >
                                  <path
                                    opacity="0.2"
                                    d="M11 6.5L8 9.5V3.5L11 6.5Z"
                                    fill="#858585"
                                  />
                                  <path
                                    d="M14.3538 6.85366L11.3538 9.85366C11.2599 9.94748 11.1327 10.0002 11 10.0002C10.8673 10.0002 10.7401 9.94748 10.6462 9.85366C10.5524 9.75984 10.4997 9.63259 10.4997 9.49991C10.4997 9.36722 10.5524 9.23998 10.6462 9.14616L13.2931 6.49991L10.6462 3.85366C10.5998 3.8072 10.5629 3.75205 10.5378 3.69135C10.5127 3.63066 10.4997 3.5656 10.4997 3.49991C10.4997 3.43421 10.5127 3.36915 10.5378 3.30846C10.5629 3.24776 10.5998 3.19261 10.6462 3.14616C10.7401 3.05234 10.8673 2.99963 11 2.99963C11.0657 2.99963 11.1308 3.01257 11.1914 3.03771C11.2521 3.06285 11.3073 3.0997 11.3538 3.14616L14.3538 6.14616C14.4002 6.19259 14.4371 6.24774 14.4623 6.30844C14.4874 6.36913 14.5004 6.4342 14.5004 6.49991C14.5004 6.56561 14.4874 6.63068 14.4623 6.69138C14.4371 6.75207 14.4002 6.80722 14.3538 6.85366ZM11.3538 6.85366L8.35375 9.85366C8.28382 9.92366 8.1947 9.97134 8.09765 9.99067C8.00061 10.01 7.90002 10.0001 7.8086 9.96222C7.71719 9.92434 7.63908 9.86019 7.58414 9.7779C7.5292 9.6956 7.49992 9.59885 7.5 9.49991V7.02303C6.1342 7.14928 4.86467 7.78068 3.93989 8.79366C3.01511 9.80665 2.50165 11.1283 2.5 12.4999C2.5 12.6325 2.44732 12.7597 2.35355 12.8535C2.25979 12.9472 2.13261 12.9999 2 12.9999C1.86739 12.9999 1.74021 12.9472 1.64645 12.8535C1.55268 12.7597 1.5 12.6325 1.5 12.4999C1.50205 10.8631 2.12068 9.28714 3.23262 8.08601C4.34457 6.88488 5.86821 6.14674 7.5 6.01866V3.49991C7.49992 3.40096 7.5292 3.30421 7.58414 3.22191C7.63908 3.13962 7.71719 3.07547 7.8086 3.03759C7.90002 2.99972 8.00061 2.98982 8.09765 3.00914C8.1947 3.02847 8.28382 3.07615 8.35375 3.14616L11.3538 6.14616C11.4002 6.19259 11.4371 6.24774 11.4623 6.30844C11.4874 6.36913 11.5004 6.4342 11.5004 6.49991C11.5004 6.56561 11.4874 6.63068 11.4623 6.69138C11.4371 6.75207 11.4002 6.80722 11.3538 6.85366ZM10.2913 6.49991L8.5 4.70678V8.29303L10.2913 6.49991Z"
                                    fill="#858585"
                                  />
                                </svg>
                              </Pagination.Next>
                            </Pagination>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </section>
            <Modal
              className="ambmodalmain1"
              show={show}
              onHide={handleClose}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  Delete Product
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                  >
                    <path
                      d="M12.0008 13.9008L7.10078 18.8008C6.91745 18.9841 6.68411 19.0758 6.40078 19.0758C6.11745 19.0758 5.88411 18.9841 5.70078 18.8008C5.51745 18.6174 5.42578 18.3841 5.42578 18.1008C5.42578 17.8174 5.51745 17.5841 5.70078 17.4008L10.6008 12.5008L5.70078 7.60078C5.51745 7.41745 5.42578 7.18411 5.42578 6.90078C5.42578 6.61745 5.51745 6.38411 5.70078 6.20078C5.88411 6.01745 6.11745 5.92578 6.40078 5.92578C6.68411 5.92578 6.91745 6.01745 7.10078 6.20078L12.0008 11.1008L16.9008 6.20078C17.0841 6.01745 17.3174 5.92578 17.6008 5.92578C17.8841 5.92578 18.1174 6.01745 18.3008 6.20078C18.4841 6.38411 18.5758 6.61745 18.5758 6.90078C18.5758 7.18411 18.4841 7.41745 18.3008 7.60078L13.4008 12.5008L18.3008 17.4008C18.4841 17.5841 18.5758 17.8174 18.5758 18.1008C18.5758 18.3841 18.4841 18.6174 18.3008 18.8008C18.1174 18.9841 17.8841 19.0758 17.6008 19.0758C17.3174 19.0758 17.0841 18.9841 16.9008 18.8008L12.0008 13.9008Z"
                      fill="white"
                    />
                  </svg>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="modal2">
                  <img
                    src="\product\delimg.svg"
                    className="tickkimgss"
                    alt="img"
                  />
                  <p className="productdel">
                    Are you sure you want to delete this product?
                  </p>
                </div>
                <div className="parentbuttons1">
                  <button
                    className="canceldel"
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="surebutt"
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Yes I’m Sure
                  </button>
                </div>
              </Modal.Body>
            </Modal>
          </div>
          <div className="uiwrheui">
            <Offcanvas
              className="offcanvasmaindiv "
              placement="bottom"
              show={show1}
              onHide={handleClose1}
            >
              <Offcanvas.Body>
                <div>
                  <p className="accordians_ptag">Filters</p>
                  <Accordion defaultActiveKey="">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Price Range </Accordion.Header>
                      <Accordion.Body>
                        <div className="outersubdiv">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              flexWrap: "wrap",
                              marginTop: "16px",
                            }}
                          >
                            <Range
                              values={values}
                              step={1}
                              min={MIN}
                              max={MAX}
                              onChange={(values) => setValues(values)}
                              renderTrack={({ props, children }) => (
                                <div
                                  {...props}
                                  style={{
                                    ...props.style,
                                    height: "8px",
                                    width: "100%",
                                    background: getTrackBackground({
                                      values,
                                      colors: ["#EEE", "#007FFF", "#EEE"],
                                      min: MIN,
                                      max: MAX,
                                    }),
                                    borderRadius: "40px",
                                    alignSelf: "center",
                                  }}
                                >
                                  {children}
                                </div>
                              )}
                              renderThumb={({ props, isDragged }) => (
                                <div
                                  {...props}
                                  style={{
                                    ...props.style,
                                    height: "16px",
                                    width: "16px",
                                    borderRadius: "50%",
                                    backgroundColor: "#007FFF",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    filter:
                                      "drop-shadow(0px 1px 6px rgba(0, 0, 0, 0.12))",
                                    border: "3px solid #FFF",
                                  }}
                                ></div>
                              )}
                            />
                          </div>
                          <div className="ttyesofinput">
                            <div>
                              <p>From</p>
                              <input
                                type="text"
                                id="fname"
                                name="fname"
                                className="inputnavvvmid"
                                placeholder="1,000"
                              />
                            </div>
                            <div>
                              <p>To</p>
                              <input
                                type="text"
                                id="fname"
                                name="fname"
                                className="inputnavvvmid"
                                placeholder="5,000"
                              />
                            </div>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    {/* <Accordion.Item eventKey="1">
                          <Accordion.Header>Manufacturer</Accordion.Header>
                          <Accordion.Body>

                          </Accordion.Body>
                        </Accordion.Item> */}
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>Select Categories</Accordion.Header>
                      <Accordion.Body>
                        <div className="homeinner">
                          <CustomSelect
                            options={options}
                            placeholder="Select Categories"
                            onChange={handleSelectChange}
                          />
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                      <Accordion.Header>Ratings</Accordion.Header>
                      <Accordion.Body className="thatsbody">
                        <div className="headraiting">
                          <div className="ratingdiv">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                            </div>
                            <div className="midlecheck">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <path
                                  d="M9.45964 1.15534L10.8791 3.9943C11.0727 4.3895 11.5889 4.76856 12.0244 4.84115L14.5972 5.2686C16.2425 5.54282 16.6296 6.73647 15.444 7.914L13.4439 9.91417C13.1051 10.2529 12.9196 10.9062 13.0245 11.374L13.5971 13.85C14.0488 15.8098 13.0083 16.568 11.2743 15.5437L8.86281 14.1162C8.42729 13.8581 7.70949 13.8581 7.2659 14.1162L4.8544 15.5437C3.12844 16.568 2.07997 15.8018 2.53162 13.85L3.10425 11.374C3.2091 10.9062 3.0236 10.2529 2.68486 9.91417L0.684683 7.914C-0.492839 6.73647 -0.113774 5.54282 1.53153 5.2686L4.10434 4.84115C4.53179 4.76856 5.04797 4.3895 5.24153 3.9943L6.66101 1.15534C7.43527 -0.385114 8.69345 -0.385114 9.45964 1.15534Z"
                                  fill="#FBBC05"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <path
                                  d="M9.45964 1.15534L10.8791 3.9943C11.0727 4.3895 11.5889 4.76856 12.0244 4.84115L14.5972 5.2686C16.2425 5.54282 16.6296 6.73647 15.444 7.914L13.4439 9.91417C13.1051 10.2529 12.9196 10.9062 13.0245 11.374L13.5971 13.85C14.0488 15.8098 13.0083 16.568 11.2743 15.5437L8.86281 14.1162C8.42729 13.8581 7.70949 13.8581 7.2659 14.1162L4.8544 15.5437C3.12844 16.568 2.07997 15.8018 2.53162 13.85L3.10425 11.374C3.2091 10.9062 3.0236 10.2529 2.68486 9.91417L0.684683 7.914C-0.492839 6.73647 -0.113774 5.54282 1.53153 5.2686L4.10434 4.84115C4.53179 4.76856 5.04797 4.3895 5.24153 3.9943L6.66101 1.15534C7.43527 -0.385114 8.69345 -0.385114 9.45964 1.15534Z"
                                  fill="#FBBC05"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <path
                                  d="M9.45964 1.15534L10.8791 3.9943C11.0727 4.3895 11.5889 4.76856 12.0244 4.84115L14.5972 5.2686C16.2425 5.54282 16.6296 6.73647 15.444 7.914L13.4439 9.91417C13.1051 10.2529 12.9196 10.9062 13.0245 11.374L13.5971 13.85C14.0488 15.8098 13.0083 16.568 11.2743 15.5437L8.86281 14.1162C8.42729 13.8581 7.70949 13.8581 7.2659 14.1162L4.8544 15.5437C3.12844 16.568 2.07997 15.8018 2.53162 13.85L3.10425 11.374C3.2091 10.9062 3.0236 10.2529 2.68486 9.91417L0.684683 7.914C-0.492839 6.73647 -0.113774 5.54282 1.53153 5.2686L4.10434 4.84115C4.53179 4.76856 5.04797 4.3895 5.24153 3.9943L6.66101 1.15534C7.43527 -0.385114 8.69345 -0.385114 9.45964 1.15534Z"
                                  fill="#FBBC05"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <path
                                  d="M9.45964 1.15534L10.8791 3.9943C11.0727 4.3895 11.5889 4.76856 12.0244 4.84115L14.5972 5.2686C16.2425 5.54282 16.6296 6.73647 15.444 7.914L13.4439 9.91417C13.1051 10.2529 12.9196 10.9062 13.0245 11.374L13.5971 13.85C14.0488 15.8098 13.0083 16.568 11.2743 15.5437L8.86281 14.1162C8.42729 13.8581 7.70949 13.8581 7.2659 14.1162L4.8544 15.5437C3.12844 16.568 2.07997 15.8018 2.53162 13.85L3.10425 11.374C3.2091 10.9062 3.0236 10.2529 2.68486 9.91417L0.684683 7.914C-0.492839 6.73647 -0.113774 5.54282 1.53153 5.2686L4.10434 4.84115C4.53179 4.76856 5.04797 4.3895 5.24153 3.9943L6.66101 1.15534C7.43527 -0.385114 8.69345 -0.385114 9.45964 1.15534Z"
                                  fill="#FBBC05"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <path
                                  d="M9.45964 1.15534L10.8791 3.9943C11.0727 4.3895 11.5889 4.76856 12.0244 4.84115L14.5972 5.2686C16.2425 5.54282 16.6296 6.73647 15.444 7.914L13.4439 9.91417C13.1051 10.2529 12.9196 10.9062 13.0245 11.374L13.5971 13.85C14.0488 15.8098 13.0083 16.568 11.2743 15.5437L8.86281 14.1162C8.42729 13.8581 7.70949 13.8581 7.2659 14.1162L4.8544 15.5437C3.12844 16.568 2.07997 15.8018 2.53162 13.85L3.10425 11.374C3.2091 10.9062 3.0236 10.2529 2.68486 9.91417L0.684683 7.914C-0.492839 6.73647 -0.113774 5.54282 1.53153 5.2686L4.10434 4.84115C4.53179 4.76856 5.04797 4.3895 5.24153 3.9943L6.66101 1.15534C7.43527 -0.385114 8.69345 -0.385114 9.45964 1.15534Z"
                                  fill="#FBBC05"
                                />
                              </svg>
                            </div>
                            <div>
                              <p className="numbrss">(243)</p>
                            </div>
                          </div>
                          <div className="ratingdiv">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                            </div>
                            <div className="midlecheck">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <path
                                  d="M9.45964 1.15534L10.8791 3.9943C11.0727 4.3895 11.5889 4.76856 12.0244 4.84115L14.5972 5.2686C16.2425 5.54282 16.6296 6.73647 15.444 7.914L13.4439 9.91417C13.1051 10.2529 12.9196 10.9062 13.0245 11.374L13.5971 13.85C14.0488 15.8098 13.0083 16.568 11.2743 15.5437L8.86281 14.1162C8.42729 13.8581 7.70949 13.8581 7.2659 14.1162L4.8544 15.5437C3.12844 16.568 2.07997 15.8018 2.53162 13.85L3.10425 11.374C3.2091 10.9062 3.0236 10.2529 2.68486 9.91417L0.684683 7.914C-0.492839 6.73647 -0.113774 5.54282 1.53153 5.2686L4.10434 4.84115C4.53179 4.76856 5.04797 4.3895 5.24153 3.9943L6.66101 1.15534C7.43527 -0.385114 8.69345 -0.385114 9.45964 1.15534Z"
                                  fill="#FBBC05"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <path
                                  d="M9.45964 1.15534L10.8791 3.9943C11.0727 4.3895 11.5889 4.76856 12.0244 4.84115L14.5972 5.2686C16.2425 5.54282 16.6296 6.73647 15.444 7.914L13.4439 9.91417C13.1051 10.2529 12.9196 10.9062 13.0245 11.374L13.5971 13.85C14.0488 15.8098 13.0083 16.568 11.2743 15.5437L8.86281 14.1162C8.42729 13.8581 7.70949 13.8581 7.2659 14.1162L4.8544 15.5437C3.12844 16.568 2.07997 15.8018 2.53162 13.85L3.10425 11.374C3.2091 10.9062 3.0236 10.2529 2.68486 9.91417L0.684683 7.914C-0.492839 6.73647 -0.113774 5.54282 1.53153 5.2686L4.10434 4.84115C4.53179 4.76856 5.04797 4.3895 5.24153 3.9943L6.66101 1.15534C7.43527 -0.385114 8.69345 -0.385114 9.45964 1.15534Z"
                                  fill="#FBBC05"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <path
                                  d="M9.45964 1.15534L10.8791 3.9943C11.0727 4.3895 11.5889 4.76856 12.0244 4.84115L14.5972 5.2686C16.2425 5.54282 16.6296 6.73647 15.444 7.914L13.4439 9.91417C13.1051 10.2529 12.9196 10.9062 13.0245 11.374L13.5971 13.85C14.0488 15.8098 13.0083 16.568 11.2743 15.5437L8.86281 14.1162C8.42729 13.8581 7.70949 13.8581 7.2659 14.1162L4.8544 15.5437C3.12844 16.568 2.07997 15.8018 2.53162 13.85L3.10425 11.374C3.2091 10.9062 3.0236 10.2529 2.68486 9.91417L0.684683 7.914C-0.492839 6.73647 -0.113774 5.54282 1.53153 5.2686L4.10434 4.84115C4.53179 4.76856 5.04797 4.3895 5.24153 3.9943L6.66101 1.15534C7.43527 -0.385114 8.69345 -0.385114 9.45964 1.15534Z"
                                  fill="#FBBC05"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <path
                                  d="M9.45964 1.15534L10.8791 3.9943C11.0727 4.3895 11.5889 4.76856 12.0244 4.84115L14.5972 5.2686C16.2425 5.54282 16.6296 6.73647 15.444 7.914L13.4439 9.91417C13.1051 10.2529 12.9196 10.9062 13.0245 11.374L13.5971 13.85C14.0488 15.8098 13.0083 16.568 11.2743 15.5437L8.86281 14.1162C8.42729 13.8581 7.70949 13.8581 7.2659 14.1162L4.8544 15.5437C3.12844 16.568 2.07997 15.8018 2.53162 13.85L3.10425 11.374C3.2091 10.9062 3.0236 10.2529 2.68486 9.91417L0.684683 7.914C-0.492839 6.73647 -0.113774 5.54282 1.53153 5.2686L4.10434 4.84115C4.53179 4.76856 5.04797 4.3895 5.24153 3.9943L6.66101 1.15534C7.43527 -0.385114 8.69345 -0.385114 9.45964 1.15534Z"
                                  fill="#FBBC05"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="18"
                                viewBox="0 0 19 18"
                                fill="none"
                              >
                                <path
                                  d="M10.9884 2.15534L12.4079 4.9943C12.6015 5.3895 13.1177 5.76856 13.5532 5.84115L16.126 6.2686C17.7713 6.54282 18.1584 7.73647 16.9728 8.914L14.9727 10.9142C14.6339 11.2529 14.4484 11.9062 14.5533 12.374L15.1259 14.85C15.5776 16.8098 14.5371 17.568 12.8031 16.5437L10.3916 15.1162C9.9561 14.8581 9.2383 14.8581 8.79471 15.1162L6.38321 16.5437C4.65725 17.568 3.60877 16.8018 4.06043 14.85L4.63306 12.374C4.7379 11.9062 4.5524 11.2529 4.21367 10.9142L2.21349 8.914C1.03597 7.73647 1.41503 6.54282 3.06034 6.2686L5.63314 5.84115C6.0606 5.76856 6.57677 5.3895 6.77034 4.9943L8.18982 2.15534C8.96408 0.614886 10.2223 0.614886 10.9884 2.15534Z"
                                  stroke="#DBDBDB"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                            <div>
                              <p className="numbrss">(187)</p>
                            </div>
                          </div>
                          <div className="ratingdiv">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                            </div>
                            <div className="midlecheck">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <path
                                  d="M9.45964 1.15534L10.8791 3.9943C11.0727 4.3895 11.5889 4.76856 12.0244 4.84115L14.5972 5.2686C16.2425 5.54282 16.6296 6.73647 15.444 7.914L13.4439 9.91417C13.1051 10.2529 12.9196 10.9062 13.0245 11.374L13.5971 13.85C14.0488 15.8098 13.0083 16.568 11.2743 15.5437L8.86281 14.1162C8.42729 13.8581 7.70949 13.8581 7.2659 14.1162L4.8544 15.5437C3.12844 16.568 2.07997 15.8018 2.53162 13.85L3.10425 11.374C3.2091 10.9062 3.0236 10.2529 2.68486 9.91417L0.684683 7.914C-0.492839 6.73647 -0.113774 5.54282 1.53153 5.2686L4.10434 4.84115C4.53179 4.76856 5.04797 4.3895 5.24153 3.9943L6.66101 1.15534C7.43527 -0.385114 8.69345 -0.385114 9.45964 1.15534Z"
                                  fill="#FBBC05"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <path
                                  d="M9.45964 1.15534L10.8791 3.9943C11.0727 4.3895 11.5889 4.76856 12.0244 4.84115L14.5972 5.2686C16.2425 5.54282 16.6296 6.73647 15.444 7.914L13.4439 9.91417C13.1051 10.2529 12.9196 10.9062 13.0245 11.374L13.5971 13.85C14.0488 15.8098 13.0083 16.568 11.2743 15.5437L8.86281 14.1162C8.42729 13.8581 7.70949 13.8581 7.2659 14.1162L4.8544 15.5437C3.12844 16.568 2.07997 15.8018 2.53162 13.85L3.10425 11.374C3.2091 10.9062 3.0236 10.2529 2.68486 9.91417L0.684683 7.914C-0.492839 6.73647 -0.113774 5.54282 1.53153 5.2686L4.10434 4.84115C4.53179 4.76856 5.04797 4.3895 5.24153 3.9943L6.66101 1.15534C7.43527 -0.385114 8.69345 -0.385114 9.45964 1.15534Z"
                                  fill="#FBBC05"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <path
                                  d="M9.45964 1.15534L10.8791 3.9943C11.0727 4.3895 11.5889 4.76856 12.0244 4.84115L14.5972 5.2686C16.2425 5.54282 16.6296 6.73647 15.444 7.914L13.4439 9.91417C13.1051 10.2529 12.9196 10.9062 13.0245 11.374L13.5971 13.85C14.0488 15.8098 13.0083 16.568 11.2743 15.5437L8.86281 14.1162C8.42729 13.8581 7.70949 13.8581 7.2659 14.1162L4.8544 15.5437C3.12844 16.568 2.07997 15.8018 2.53162 13.85L3.10425 11.374C3.2091 10.9062 3.0236 10.2529 2.68486 9.91417L0.684683 7.914C-0.492839 6.73647 -0.113774 5.54282 1.53153 5.2686L4.10434 4.84115C4.53179 4.76856 5.04797 4.3895 5.24153 3.9943L6.66101 1.15534C7.43527 -0.385114 8.69345 -0.385114 9.45964 1.15534Z"
                                  fill="#FBBC05"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="18"
                                viewBox="0 0 19 18"
                                fill="none"
                              >
                                <path
                                  d="M10.9884 2.15534L12.4079 4.9943C12.6015 5.3895 13.1177 5.76856 13.5532 5.84115L16.126 6.2686C17.7713 6.54282 18.1584 7.73647 16.9728 8.914L14.9727 10.9142C14.6339 11.2529 14.4484 11.9062 14.5533 12.374L15.1259 14.85C15.5776 16.8098 14.5371 17.568 12.8031 16.5437L10.3916 15.1162C9.9561 14.8581 9.2383 14.8581 8.79471 15.1162L6.38321 16.5437C4.65725 17.568 3.60877 16.8018 4.06043 14.85L4.63306 12.374C4.7379 11.9062 4.5524 11.2529 4.21367 10.9142L2.21349 8.914C1.03597 7.73647 1.41503 6.54282 3.06034 6.2686L5.63314 5.84115C6.0606 5.76856 6.57677 5.3895 6.77034 4.9943L8.18982 2.15534C8.96408 0.614886 10.2223 0.614886 10.9884 2.15534Z"
                                  stroke="#DBDBDB"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="18"
                                viewBox="0 0 19 18"
                                fill="none"
                              >
                                <path
                                  d="M10.9884 2.15534L12.4079 4.9943C12.6015 5.3895 13.1177 5.76856 13.5532 5.84115L16.126 6.2686C17.7713 6.54282 18.1584 7.73647 16.9728 8.914L14.9727 10.9142C14.6339 11.2529 14.4484 11.9062 14.5533 12.374L15.1259 14.85C15.5776 16.8098 14.5371 17.568 12.8031 16.5437L10.3916 15.1162C9.9561 14.8581 9.2383 14.8581 8.79471 15.1162L6.38321 16.5437C4.65725 17.568 3.60877 16.8018 4.06043 14.85L4.63306 12.374C4.7379 11.9062 4.5524 11.2529 4.21367 10.9142L2.21349 8.914C1.03597 7.73647 1.41503 6.54282 3.06034 6.2686L5.63314 5.84115C6.0606 5.76856 6.57677 5.3895 6.77034 4.9943L8.18982 2.15534C8.96408 0.614886 10.2223 0.614886 10.9884 2.15534Z"
                                  stroke="#DBDBDB"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                            <div>
                              <p className="numbrss">(115)</p>
                            </div>
                          </div>
                          <div className="ratingdiv">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                            </div>
                            <div className="midlecheck">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <path
                                  d="M9.45964 1.15534L10.8791 3.9943C11.0727 4.3895 11.5889 4.76856 12.0244 4.84115L14.5972 5.2686C16.2425 5.54282 16.6296 6.73647 15.444 7.914L13.4439 9.91417C13.1051 10.2529 12.9196 10.9062 13.0245 11.374L13.5971 13.85C14.0488 15.8098 13.0083 16.568 11.2743 15.5437L8.86281 14.1162C8.42729 13.8581 7.70949 13.8581 7.2659 14.1162L4.8544 15.5437C3.12844 16.568 2.07997 15.8018 2.53162 13.85L3.10425 11.374C3.2091 10.9062 3.0236 10.2529 2.68486 9.91417L0.684683 7.914C-0.492839 6.73647 -0.113774 5.54282 1.53153 5.2686L4.10434 4.84115C4.53179 4.76856 5.04797 4.3895 5.24153 3.9943L6.66101 1.15534C7.43527 -0.385114 8.69345 -0.385114 9.45964 1.15534Z"
                                  fill="#FBBC05"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <path
                                  d="M9.45964 1.15534L10.8791 3.9943C11.0727 4.3895 11.5889 4.76856 12.0244 4.84115L14.5972 5.2686C16.2425 5.54282 16.6296 6.73647 15.444 7.914L13.4439 9.91417C13.1051 10.2529 12.9196 10.9062 13.0245 11.374L13.5971 13.85C14.0488 15.8098 13.0083 16.568 11.2743 15.5437L8.86281 14.1162C8.42729 13.8581 7.70949 13.8581 7.2659 14.1162L4.8544 15.5437C3.12844 16.568 2.07997 15.8018 2.53162 13.85L3.10425 11.374C3.2091 10.9062 3.0236 10.2529 2.68486 9.91417L0.684683 7.914C-0.492839 6.73647 -0.113774 5.54282 1.53153 5.2686L4.10434 4.84115C4.53179 4.76856 5.04797 4.3895 5.24153 3.9943L6.66101 1.15534C7.43527 -0.385114 8.69345 -0.385114 9.45964 1.15534Z"
                                  fill="#FBBC05"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="18"
                                viewBox="0 0 19 18"
                                fill="none"
                              >
                                <path
                                  d="M10.9884 2.15534L12.4079 4.9943C12.6015 5.3895 13.1177 5.76856 13.5532 5.84115L16.126 6.2686C17.7713 6.54282 18.1584 7.73647 16.9728 8.914L14.9727 10.9142C14.6339 11.2529 14.4484 11.9062 14.5533 12.374L15.1259 14.85C15.5776 16.8098 14.5371 17.568 12.8031 16.5437L10.3916 15.1162C9.9561 14.8581 9.2383 14.8581 8.79471 15.1162L6.38321 16.5437C4.65725 17.568 3.60877 16.8018 4.06043 14.85L4.63306 12.374C4.7379 11.9062 4.5524 11.2529 4.21367 10.9142L2.21349 8.914C1.03597 7.73647 1.41503 6.54282 3.06034 6.2686L5.63314 5.84115C6.0606 5.76856 6.57677 5.3895 6.77034 4.9943L8.18982 2.15534C8.96408 0.614886 10.2223 0.614886 10.9884 2.15534Z"
                                  stroke="#DBDBDB"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="18"
                                viewBox="0 0 19 18"
                                fill="none"
                              >
                                <path
                                  d="M10.9884 2.15534L12.4079 4.9943C12.6015 5.3895 13.1177 5.76856 13.5532 5.84115L16.126 6.2686C17.7713 6.54282 18.1584 7.73647 16.9728 8.914L14.9727 10.9142C14.6339 11.2529 14.4484 11.9062 14.5533 12.374L15.1259 14.85C15.5776 16.8098 14.5371 17.568 12.8031 16.5437L10.3916 15.1162C9.9561 14.8581 9.2383 14.8581 8.79471 15.1162L6.38321 16.5437C4.65725 17.568 3.60877 16.8018 4.06043 14.85L4.63306 12.374C4.7379 11.9062 4.5524 11.2529 4.21367 10.9142L2.21349 8.914C1.03597 7.73647 1.41503 6.54282 3.06034 6.2686L5.63314 5.84115C6.0606 5.76856 6.57677 5.3895 6.77034 4.9943L8.18982 2.15534C8.96408 0.614886 10.2223 0.614886 10.9884 2.15534Z"
                                  stroke="#DBDBDB"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="18"
                                viewBox="0 0 19 18"
                                fill="none"
                              >
                                <path
                                  d="M10.9884 2.15534L12.4079 4.9943C12.6015 5.3895 13.1177 5.76856 13.5532 5.84115L16.126 6.2686C17.7713 6.54282 18.1584 7.73647 16.9728 8.914L14.9727 10.9142C14.6339 11.2529 14.4484 11.9062 14.5533 12.374L15.1259 14.85C15.5776 16.8098 14.5371 17.568 12.8031 16.5437L10.3916 15.1162C9.9561 14.8581 9.2383 14.8581 8.79471 15.1162L6.38321 16.5437C4.65725 17.568 3.60877 16.8018 4.06043 14.85L4.63306 12.374C4.7379 11.9062 4.5524 11.2529 4.21367 10.9142L2.21349 8.914C1.03597 7.73647 1.41503 6.54282 3.06034 6.2686L5.63314 5.84115C6.0606 5.76856 6.57677 5.3895 6.77034 4.9943L8.18982 2.15534C8.96408 0.614886 10.2223 0.614886 10.9884 2.15534Z"
                                  stroke="#DBDBDB"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                            <div>
                              <p className="numbrss">(34)</p>
                            </div>
                          </div>
                          <div className="ratingdiv newwwray">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckDefault"
                              />
                            </div>
                            <div className="midlecheck">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                              >
                                <path
                                  d="M9.45964 1.15534L10.8791 3.9943C11.0727 4.3895 11.5889 4.76856 12.0244 4.84115L14.5972 5.2686C16.2425 5.54282 16.6296 6.73647 15.444 7.914L13.4439 9.91417C13.1051 10.2529 12.9196 10.9062 13.0245 11.374L13.5971 13.85C14.0488 15.8098 13.0083 16.568 11.2743 15.5437L8.86281 14.1162C8.42729 13.8581 7.70949 13.8581 7.2659 14.1162L4.8544 15.5437C3.12844 16.568 2.07997 15.8018 2.53162 13.85L3.10425 11.374C3.2091 10.9062 3.0236 10.2529 2.68486 9.91417L0.684683 7.914C-0.492839 6.73647 -0.113774 5.54282 1.53153 5.2686L4.10434 4.84115C4.53179 4.76856 5.04797 4.3895 5.24153 3.9943L6.66101 1.15534C7.43527 -0.385114 8.69345 -0.385114 9.45964 1.15534Z"
                                  fill="#FBBC05"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="18"
                                viewBox="0 0 19 18"
                                fill="none"
                              >
                                <path
                                  d="M10.9884 2.15534L12.4079 4.9943C12.6015 5.3895 13.1177 5.76856 13.5532 5.84115L16.126 6.2686C17.7713 6.54282 18.1584 7.73647 16.9728 8.914L14.9727 10.9142C14.6339 11.2529 14.4484 11.9062 14.5533 12.374L15.1259 14.85C15.5776 16.8098 14.5371 17.568 12.8031 16.5437L10.3916 15.1162C9.9561 14.8581 9.2383 14.8581 8.79471 15.1162L6.38321 16.5437C4.65725 17.568 3.60877 16.8018 4.06043 14.85L4.63306 12.374C4.7379 11.9062 4.5524 11.2529 4.21367 10.9142L2.21349 8.914C1.03597 7.73647 1.41503 6.54282 3.06034 6.2686L5.63314 5.84115C6.0606 5.76856 6.57677 5.3895 6.77034 4.9943L8.18982 2.15534C8.96408 0.614886 10.2223 0.614886 10.9884 2.15534Z"
                                  stroke="#DBDBDB"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="18"
                                viewBox="0 0 19 18"
                                fill="none"
                              >
                                <path
                                  d="M10.9884 2.15534L12.4079 4.9943C12.6015 5.3895 13.1177 5.76856 13.5532 5.84115L16.126 6.2686C17.7713 6.54282 18.1584 7.73647 16.9728 8.914L14.9727 10.9142C14.6339 11.2529 14.4484 11.9062 14.5533 12.374L15.1259 14.85C15.5776 16.8098 14.5371 17.568 12.8031 16.5437L10.3916 15.1162C9.9561 14.8581 9.2383 14.8581 8.79471 15.1162L6.38321 16.5437C4.65725 17.568 3.60877 16.8018 4.06043 14.85L4.63306 12.374C4.7379 11.9062 4.5524 11.2529 4.21367 10.9142L2.21349 8.914C1.03597 7.73647 1.41503 6.54282 3.06034 6.2686L5.63314 5.84115C6.0606 5.76856 6.57677 5.3895 6.77034 4.9943L8.18982 2.15534C8.96408 0.614886 10.2223 0.614886 10.9884 2.15534Z"
                                  stroke="#DBDBDB"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="18"
                                viewBox="0 0 19 18"
                                fill="none"
                              >
                                <path
                                  d="M10.9884 2.15534L12.4079 4.9943C12.6015 5.3895 13.1177 5.76856 13.5532 5.84115L16.126 6.2686C17.7713 6.54282 18.1584 7.73647 16.9728 8.914L14.9727 10.9142C14.6339 11.2529 14.4484 11.9062 14.5533 12.374L15.1259 14.85C15.5776 16.8098 14.5371 17.568 12.8031 16.5437L10.3916 15.1162C9.9561 14.8581 9.2383 14.8581 8.79471 15.1162L6.38321 16.5437C4.65725 17.568 3.60877 16.8018 4.06043 14.85L4.63306 12.374C4.7379 11.9062 4.5524 11.2529 4.21367 10.9142L2.21349 8.914C1.03597 7.73647 1.41503 6.54282 3.06034 6.2686L5.63314 5.84115C6.0606 5.76856 6.57677 5.3895 6.77034 4.9943L8.18982 2.15534C8.96408 0.614886 10.2223 0.614886 10.9884 2.15534Z"
                                  stroke="#DBDBDB"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="18"
                                viewBox="0 0 19 18"
                                fill="none"
                              >
                                <path
                                  d="M10.9884 2.15534L12.4079 4.9943C12.6015 5.3895 13.1177 5.76856 13.5532 5.84115L16.126 6.2686C17.7713 6.54282 18.1584 7.73647 16.9728 8.914L14.9727 10.9142C14.6339 11.2529 14.4484 11.9062 14.5533 12.374L15.1259 14.85C15.5776 16.8098 14.5371 17.568 12.8031 16.5437L10.3916 15.1162C9.9561 14.8581 9.2383 14.8581 8.79471 15.1162L6.38321 16.5437C4.65725 17.568 3.60877 16.8018 4.06043 14.85L4.63306 12.374C4.7379 11.9062 4.5524 11.2529 4.21367 10.9142L2.21349 8.914C1.03597 7.73647 1.41503 6.54282 3.06034 6.2686L5.63314 5.84115C6.0606 5.76856 6.57677 5.3895 6.77034 4.9943L8.18982 2.15534C8.96408 0.614886 10.2223 0.614886 10.9884 2.15534Z"
                                  stroke="#DBDBDB"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </div>
                            <div>
                              <p className="numbrss">(2)</p>
                            </div>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                  <div className="headofbutton">
                    <button className="cancelbutttton">Cancel</button>
                    <button className="applylbutttton">Apply</button>
                  </div>
                </div>
              </Offcanvas.Body>
            </Offcanvas>
          </div>
        </>
      )}
    </>
  );
};

export default Users;
